/**
 * @generated SignedSource<<8b51bd4a855c9ae939122eba6d4df6c0>>
 * @relayHash e3aab252ccba714e238105505c5d2361
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 619313d5063da6c0c7d98d035459a964afbdee8641cc700602204aa1189437dd

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBoardQuery } from './JiraBoardQuery.graphql';

const node: PreloadableConcreteRequest<JiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "619313d5063da6c0c7d98d035459a964afbdee8641cc700602204aa1189437dd",
    "metadata": {},
    "name": "JiraBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
